/**
 * Page component for the server-driven wizard route: /wizard/:instanceId
 *
 * Extracts instanceId from URL params and renders the ServerDrivenWizardProvider
 * wrapping the existing OnboardingWizard UI shell.
 */

import { useParams, useNavigate } from "react-router-dom";
import { ServerDrivenWizardProvider } from "../components/wizard/ServerDrivenWizardProvider";
import { OnboardingWizard } from "../components/onboarding/OnboardingWizard";
import { AlertCircle } from "lucide-react";

export function WizardPage() {
  const { instanceId } = useParams<{ instanceId: string }>();
  const navigate = useNavigate();

  if (!instanceId) {
    return (
      <div className="min-h-[100dvh] bg-muted flex flex-col items-center justify-center gap-4">
        <AlertCircle className="h-12 w-12 text-destructive" />
        <p className="text-destructive text-lg font-medium">
          No wizard instance specified
        </p>
        <button
          onClick={() => navigate("/")}
          className="px-4 py-2 text-sm font-medium text-nara-orange hover:underline"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  return (
    <ServerDrivenWizardProvider instanceId={instanceId}>
      <OnboardingWizard />
    </ServerDrivenWizardProvider>
  );
}
